import ShoppingBagCheckmark from '../../src/legacy/ShoppingBagCheckmark';
export default ShoppingBagCheckmark;
